import { Language } from "../domain/Language";
import { CounterType } from "../domain/CounterType";
export function getEditorState() {
    const langShortName = localStorage.translitLang || navigator.language.substring(0, 2).toLowerCase();
    return {
        contents: transformOrDefault(localStorage.contents, JSON.parse, null),
        cursorPosition: getOrDefault(parseInt(localStorage.cursorPosition || "-1"), value => !isNaN(value), -1),
        translitLang: Language.getByShortName(langShortName) || Language.Ru,
        translitEnabled: localStorage.translitEnabled != "false",
        counterType: CounterType.valueOf(localStorage.counterType) || CounterType.word,
        keyboardHidden: localStorage.keyboardHidden == "true",
        aboutHidden: localStorage.aboutHidden == "true"
    };
}
function getOrDefault(value, isCorrect, defaultValue) {
    return isCorrect(value) ? value : defaultValue;
}
function transformOrDefault(input, transform, defaultValue) {
    if (!input)
        return defaultValue;
    try {
        return transform(input);
    }
    catch (e) {
        return defaultValue;
    }
}
